import { DownOutlined, MoreOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { Dropdown, Space, Card, Button } from 'antd';
import React from 'react';

const mockValues = ['Metis', 'Adrastea', 'Amalthea', 'Thebe', 'Europa', 'Callisto', 'Leda', 'Themisto', 'Lysithea', 'Helike'];
const options = mockValues.map((value) => {
  return {
    key: value.toLowerCase(),
    label: value,
    disabled: false,
  }
});

const indexToDisable = Math.floor(Math.random() * mockValues.length);
options[indexToDisable].disabled = true;

function Dropdowns() {
  return (
    <Card title="Dropdown">
      <Space size="large">

        <Dropdown menu={{ items: options }} trigger={['click']}>
          <Space>
            Moon
            <DownOutlined />
          </Space>
        </Dropdown>

        <Dropdown menu={{ items: options }} trigger={['click']}>
          <a>
            <Space>
              Moon
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>

        <Dropdown menu={{ items: options }} trigger={['click']} disabled>
          <a>
            <Space>
              Moon
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>

        <Dropdown menu={{ items: options }} trigger={['click']}>
          <Button>
            <Space>
              Moon
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>

        <Dropdown menu={{ items: options }} trigger={['click']} disabled>
          <Button>
            <Space>
              Moon
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>

        <Dropdown menu={{ items: options }} trigger={['click']}>
          <Button icon={<MoreOutlined />} />
        </Dropdown>

        <Dropdown menu={{ items: options }} trigger={['click']} disabled>
          <Button icon={<SettingOutlined />} />
        </Dropdown>

      </Space>
    </Card>
  )
}


export default Dropdowns;
